$('[data-fancybox="images"], [data-fancybox="insta_images"]').fancybox({
    // baseClass: "fancybox-custom-layout",
    infobar: !1,
    touch: {vertical: !1},
    buttons: ["close", "thumbs"],
    animationEffect: "fade",
    transitionEffect: "fade",
    // preventCaptionOverlap: !1,
    idleTime: !1,
    gutter: 0,
    // caption: function (a) {
    //     return '<div><p class="fancy-nav"><span data-fancybox-index></span> / <span data-fancybox-count></span></p>' + $(this).find(".caption").html() + "</div>"
    // }
});
